import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";

import { updateTabPath } from '../../../store/actions';

export default function LeftMenuInsight({ expanded, getLeftMenuExpandActionFromChild }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const themeMode = useSelector(state => state.themeMode);
    // const currentSurvey = useSelector(state => state.currentSurvey);
    const topMenuTabs = useSelector(state => state.topMenuTabs);

    // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
    const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;

    const [insightMenuItems, setInsightMenuItems] = useState([
        {
            id: 1,
            name: "Insight Summary",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 2,
            name: "Strengths & Weaknesses",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 3,
            name: "Findings",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 4,
            name: "Recommendations & Roadmap",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 5,
            name: "Gap Analysis",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 6,
            name: "Compare",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 7,
            name: "Heatmap",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 8,
            name: "Main Report",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        },
        {
            id: 9,
            name: "Benchmarked Description",
            icon: (
                <svg
                    strokeWidth="1.5"
                    stroke={themeMode === "dark" ? "currentColor" : "black"}
                    className="size-3.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                    <path
                        d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
                        fill={themeMode === "dark" ? "currentColor" : "black"}
                    />
                </svg>
            ),
        }





        // {
        //     id: 12,
        //     name: "Download Reports",
        //     icon: (
        //         <svg
        //             strokeWidth="1.5"
        //             stroke={themeMode === "dark" ? "currentColor" : "black"}
        //             className="size-3.5"
        //             viewBox="0 0 24 24"
        //             fill="none"
        //             xmlns="http://www.w3.org/2000/svg"
        //         >
        //             <path
        //                 d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //             <path
        //                 d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //         </svg>
        //     ),
        // },

        // {
        //     id: 7,
        //     name: "Trend Analysis",
        //     icon: (
        //         <svg
        //             strokeWidth="1.5"
        //             stroke={themeMode === "dark" ? "currentColor" : "black"}
        //             className="size-3.5"
        //             viewBox="0 0 24 24"
        //             fill="none"
        //             xmlns="http://www.w3.org/2000/svg"
        //         >
        //             <path
        //                 d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //             <path
        //                 d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //         </svg>
        //     ),
        // },

        // {
        //     id: 11,
        //     name: "Roadmap",
        //     icon: (
        //         <svg
        //             strokeWidth="1.5"
        //             stroke={themeMode === "dark" ? "currentColor" : "black"}
        //             className="size-3.5"
        //             viewBox="0 0 24 24"
        //             fill="none"
        //             xmlns="http://www.w3.org/2000/svg"
        //         >
        //             <path
        //                 d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //             <path
        //                 d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //         </svg>
        //     ),
        // },

        // {
        //     id: 3,
        //     name: "Section Reports",
        //     icon: (
        //         <svg
        //             strokeWidth="1.5"
        //             stroke={themeMode === "dark" ? "currentColor" : "black"}
        //             className="size-3.5"
        //             viewBox="0 0 24 24"
        //             fill="none"
        //             xmlns="http://www.w3.org/2000/svg"
        //         >
        //             <path
        //                 d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //             <path
        //                 d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //         </svg>
        //     ),
        // },
        // {
        //     id: 3,
        //     name: "Detail Analysis",
        //     icon: (
        //         <svg
        //             strokeWidth="1.5"
        //             stroke={themeMode === "dark" ? "currentColor" : "black"}
        //             className="size-3.5"
        //             viewBox="0 0 24 24"
        //             fill="none"
        //             xmlns="http://www.w3.org/2000/svg"
        //         >
        //             <path
        //                 d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //             <path
        //                 d="M10.5 16.75C8.71 16.75 7.25 15.29 7.25 13.5C7.25 10.05 10.05 7.25 13.5 7.25C15.29 7.25 16.75 8.71 16.75 10.5C16.75 13.95 13.95 16.75 10.5 16.75ZM13.5 8.75C10.88 8.75 8.75 10.88 8.75 13.5C8.75 14.46 9.54 15.25 10.5 15.25C13.12 15.25 15.25 13.12 15.25 10.5C15.25 9.54 14.46 8.75 13.5 8.75Z"
        //                 fill={themeMode === "dark" ? "currentColor" : "black"}
        //             />
        //         </svg>
        //     ),
        // },
    ]);
    const [selectedInsightMenuItem, setSelectedInsightMenuItem] = useState(insightMenuItems[0]);

    useEffect(() => {
        if (insightMenuItems.length > 0) {
            if (location.pathname.includes("insight-summary")) {
                setSelectedInsightMenuItem(insightMenuItems[0]);
            } else if (location.pathname.includes("strengths-weaknesses")) {
                setSelectedInsightMenuItem(insightMenuItems[1]);
            } else if (location.pathname.includes("findings")) {
                setSelectedInsightMenuItem(insightMenuItems[2]);
            } else if (location.pathname.includes("recommendations-roadmap")) {
                setSelectedInsightMenuItem(insightMenuItems[3]);
            } else if (location.pathname.includes("gap-analysis")) {
                setSelectedInsightMenuItem(insightMenuItems[4]);
            } else if (location.pathname.includes("insight-sankey")) {
                setSelectedInsightMenuItem(insightMenuItems[5]);
            } else if (location.pathname.includes("heatmap")) {
                setSelectedInsightMenuItem(insightMenuItems[6]);
            } else if (location.pathname.includes("main-report")) {
                setSelectedInsightMenuItem(insightMenuItems[7]);
            } else if (location.pathname.includes("benchmarked-description")) {
                setSelectedInsightMenuItem(insightMenuItems[8]);
            } 
            // else if (location.pathname.includes("roadmap")) {
            //     setSelectedInsightMenuItem(insightMenuItems[9]);
            // }
            // else if (location.pathname.includes("download-reports")) {
            //     setSelectedInsightMenuItem(insightMenuItems[10]);
            // }
        }
    }, [insightMenuItems, location.pathname]);


    const selectInsightMenuItem = (item) => {
        console.log("leftmenu item",item)
        if (window.innerWidth < 1024 && expanded) {
            getLeftMenuExpandActionFromChild(false)
        }
        console.log("item : ", item);
        console.log("currentSurvey : ", currentSurvey);
        if (item.open !== undefined) {
            item.open = !item.open;
            setInsightMenuItems([...insightMenuItems]);
        } else {
            setSelectedInsightMenuItem(item);
        }
        if (item.name === "Insight Summary") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Insight Summary', `/surveys/${currentSurvey.ID}/insight-summary`));
            window.scrollTo(0, 0);
            navigate("/surveys/" + currentSurvey.ID + "/insight-summary");
        } else if (item.name === "Main Report") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Main Report', `/surveys/${currentSurvey.ID}/insight-main-report`));
            window.scrollTo(0, 0);

            navigate("/surveys/" + currentSurvey.ID + "/insight-main-report");
        } else if (item.name === "Compare") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Insight Compare', `/surveys/${currentSurvey.ID}/insight-sankey`));
            window.scrollTo(0, 0);
            navigate("/surveys/" + currentSurvey.ID + "/insight-sankey");
        } 
        else if (item.name === "Download Reports") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Download Reports', `/surveys/${currentSurvey.ID}/insight-download-reports`));
            window.scrollTo(0, 0);
            navigate("/surveys/" + currentSurvey.ID + "/insight-download-reports");
        }
        else if (item.name === "Strengths & Weaknesses") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Strengths & Weaknesses', `/surveys/${currentSurvey.ID}/insight-strengths-weaknesses`));
            window.scrollTo(0, 0);
            navigate("/surveys/" + currentSurvey.ID + "/insight-strengths-weaknesses");
        } else if (item.name === "Gap Analysis") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Gap Analysis', `/surveys/${currentSurvey.ID}/insight-gap-analysis`));
            window.scrollTo(0, 0);
            navigate("/surveys/" + currentSurvey.ID + "/insight-gap-analysis");
        } else if (item.name === "Benchmarked Description") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Benchmarked Description', `/surveys/${currentSurvey.ID}/insight-benchmarked-description`));
            window.scrollTo(0, 0);
            navigate("/surveys/" + currentSurvey.ID + "/insight-benchmarked-description");
        } else if (item.name === "Heatmap") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Heatmap', `/surveys/${currentSurvey.ID}/-insight-heatmap`));
            window.scrollTo(0, 0);
            navigate("/surveys/" + currentSurvey.ID + "/insight-heatmap");
        } else if (item.name === "Findings") {
            console.log("are we in")
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Findings', `/surveys/${currentSurvey.ID}/insight-findings`));
            window.scrollTo(0, 0); 
            navigate("/surveys/" + currentSurvey.ID + "/insight-findings");
        } else if (item.name === "Recommendations & Roadmap") {
            dispatch(updateTabPath(topMenuTabs.activeTab, 'Recommendations & Roadmap', `/surveys/${currentSurvey.ID}/insight-recommendations-roadmap`));
            window.scrollTo(0, 0); 
            navigate("/surveys/" + currentSurvey.ID + "/insight-recommendations-roadmap");
        } 
        // else if (item.name === "Roadmap") {
        //     dispatch(updateTabPath(topMenuTabs.activeTab, 'Roadmap', `/surveys/${currentSurvey.ID}/roadmap`));
        //     navigate("/surveys/" + currentSurvey.ID + "/roadmap");
        // }
    };

    return (
        <div>
            <div className="flex cursor-default items-center justify-between rounded-lg pt-[0.75rem] pr-[0.75rem] pb-[1.5rem] pl-[1.25rem] text-[1.25rem] font-bold space-x-2">
                <span
                    className={` whitespace-nowrap break-words text-ellipsis  min-w-0 w-full cursor-default ${themeMode === "dark" ? "text-white" : "text-[#0F121A]"
                        }`}
                >
                    Insight
                </span>
            </div>

            <ul className="px-3 space-y-0 flex flex-col">
                {insightMenuItems.map((cmItem, index) =>
                    (cmItem.name !== "Benchmarked Description" || (cmItem.name === "Benchmarked Description" && currentSurvey?.stages !== undefined)) &&
                    (
                        <li
                            key={cmItem.id}
                            className=" flex flex-col min-h-[2rem] my-0 py-0 group"
                            onClick={() => selectInsightMenuItem(cmItem)}
                        >
                            <div
                                className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark"
                                    ? "text-white  "
                                    : "text-gray-500  "
                                    }
                        ${selectedInsightMenuItem.id === cmItem.id
                                        ? "bg-[#A5BDFF1A]"
                                        : "hover:bg-[#A5BDFF1A]"
                                    }`}
                            >
                                <div className="flex items-center justify-between w-full">
                                    <div className="flex items-center">
                                        {/* <span className={`mr-2`}>{cmItem.icon}</span> */}
                                        <span
                                            className={`text-sm font-normal whitespace-nowrap break-words text-ellipsis overflow-hidden min-w-0 ${themeMode === "dark"
                                                ? `${selectedInsightMenuItem.id ===
                                                    cmItem.id
                                                    ? "text-[#4D7FF5]"
                                                    : "focus:ring-2 focus:ring-blue-500 "
                                                }`
                                                : `text-[#0F121A] ${selectedInsightMenuItem.id ===
                                                    cmItem.id
                                                    ? "text-[#3566E2]"
                                                    : "focus:ring-2 focus:ring-blue-500 "
                                                }`
                                                }`}
                                        >
                                            {cmItem.name}
                                        </span>
                                    </div>

                                    {cmItem.children && (
                                        <div className="flex items-center">
                                            <span className="mr-2">
                                                <svg
                                                    className="size-4"
                                                    fill="currentColor"
                                                    viewBox="0 0 16 16"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    transform={
                                                        !cmItem.open ? "rotate(270)" : ""
                                                    }
                                                >
                                                    <path d="M7.8,10.8L11.7,7H4L7.8,10.8z"></path>
                                                </svg>
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {cmItem.children && cmItem.open && (
                                <ul className="pl-6 space-y-0 flex flex-col">
                                    {cmItem.children.map((child) => (
                                        <li
                                            key={child.id}
                                            className=" flex flex-col min-h-[2rem] my-0 py-0 group"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                selectInsightMenuItem(child);
                                            }}
                                        >
                                            <div
                                                className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark"
                                                    ? "text-white  "
                                                    : "text-gray-500  "
                                                    }
                                        ${selectedInsightMenuItem.id === child.id
                                                        ? "bg-[#A5BDFF1A]"
                                                        : "hover:bg-[#A5BDFF1A]"
                                                    }`}
                                            >
                                                <div className="flex items-center">
                                                    <span className={`mr-2`}>
                                                        {child.icon}
                                                    </span>
                                                    <span
                                                        className={`text-sm font-normal whitespace-nowrap break-words text-ellipsis overflow-hidden min-w-0 ${themeMode === "dark"
                                                            ? `${selectedInsightMenuItem.id ===
                                                                child.id
                                                                ? "text-[#4D7FF5]"
                                                                : "focus:ring-2 focus:ring-blue-500 "
                                                            }`
                                                            : `text-[#0F121A] ${selectedInsightMenuItem.id ===
                                                                child.id
                                                                ? "text-[#3566E2]"
                                                                : "focus:ring-2 focus:ring-blue-500 "
                                                            }`
                                                            }`}
                                                    >
                                                        {child.name}
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
            </ul>

            <div
                className={`h-px mt-4 ${themeMode === "dark" ? "bg-[#ffffff17]" : "bg-[#0000001a]"
                    }`}
            ></div>
        </div>
    )
}